import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const HistoryPage = () => {
  useEffect(() => {
    document.title = 'History | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/rules">
          <div id="stick_right"></div>
        </Link>

        {/* History Content */}
        <div id="basic">
          <h3 className="heading3">HISTORY AND ACTIVITIES OF THE AMATEUR BASEBALL FEDERATION OF INDIA</h3>
          <p className="basic_p">
            Baseball game was introduced in our country by the <strong>Amateur Baseball Federation of India</strong>. 
            The Federation was established in December 1983 with an object to promote this game. On 11th December 1983 
            some Baseball lovers from Delhi, Manipur, Haryana, Gujarat, M.P and West Bengal met at Rohtak (Haryana) 
            and agreed to form a baseball federation to promote baseball game through out the country. The Baseball 
            Leaders also agreed that the Federation should become a member of <strong>Asian baseball Federation and 
            International Baseball Association.</strong> The leading persons at that time were <strong>Mr.P.C. Bhardwaj 
            ( Delhi ) and Mr. E.Bijoy Singh (Manipur)</strong>. Mr.P.C.Bhardwaj (Delhi) was appointed as Hony. Secretary 
            and given responsibility to approach Asian and International Baseball Authority for membership.
          </p>
          <p className="basic_p">
            On <strong>16th Sept. 1984</strong> a seminar was organized to discuss the basic bylaws and to hold the 
            <strong>Ist National Baseball Championship</strong> to popularize this game, An application was moved to 
            International Baseball Association for Affiliation. An extraordinary Congress and <strong>13th Baseball 
            Asia Championship Series was to be held from 19th Jan. 1985 to 31 Jan. 1985 at Perth (Australia).</strong> 
            Bhardwaj Hony. Secretary A.B.F.I Attended the 13th Asian Baseball Championship Series at Perth. ABFI was 
            approved as a member of B.F.A on 19th Jan 1985 at Seoul. Indian Olympic Association also recognized 
            Amateur Baseball Federation of India
          </p>
          <p className="basic_p">
            Ist National Baseball Championship was organized by Baseball Association, Delhi from 25th Feb to 28th Feb 
            1985 at New Delhi. The Federation also introduced this game for women. A.B.F.I was deeply grateful to 
            B.F.A for providing the Baseball equipment.
          </p>
          <p className="basic_p">
            The Federation is determined to promote Baseball game through out the country. At present <strong>26</strong> 
            States/UT are the affiliated member of the Federation. The federation has organized <strong>30</strong> 
            Senior National Baseball Championship, <strong>25</strong> Junior National Baseball Championship, 
            <strong>24</strong> Sub-junior National Championship, apart from <strong>13</strong> National Little 
            League Tournament between 11-13 years age group. The Indian team won Bronze medal in 1995 & Silver medal 
            in 1999 in the Asian Cup Baseball championship at Internationals Level. Indian team also participated in 
            "AA" and "AAA" Championship held at Seoul and Taiwan in which Indian team performance was appreciable. 
            The federation has been sending participants under 11 years in the world children Baseball Fair on the 
            invitation from WCBF. The Indian woman team recently participated in 3rd woman world cup at Matsuyama, 
            Japan in 2008.
          </p>
          <p className="basic_p">
            The Baseball game has been included in the school game by the <strong>School Games Federation of India</strong> 
            since 1998. The Federation succeeded to introduced Baseball game at Grass Route Level. Sports Authority 
            of India has introduced certificate course for Baseball Coaches at N.I.S Patiala.
          </p>
          <p className="basic_p">
            A.B.F.I.'s most urgent task is to make Baseball Tremendously popular in India. The Federation will do 
            its level best to achieve the goal
          </p>
        </div>

        {/* International Baseball History */}
        <div id="basic">
          <h3 className="heading3">THE HISTORY OF INTERNATIONAL BASEBALL</h3>
          <p className="basic_p">
            Although it is clear that modern baseball developed in North America, the exact origin of the game is 
            difficult to determine. Most scholars believe that baseball evolved from a variety of similar games 
            that have been played for centuries. A popular legend claims that Abner Doubleday, who became a Union 
            officer in the American Civil War (1861-1865), invented baseball in Cooperstown, New York, in 1839. 
            Although there is little support for this story, the Baseball Hall of Fame Museum is located there 
            because of it.
          </p>
        </div>

        {/* Baseball Around the World */}
        <div id="basic">
          <h3 className="heading3">BASEBALL AROUND THE WORLD</h3>
          <p className="basic_p">
            Baseball, which is now an Olympic sport, is played in many other countries, especially in Latin America 
            (particularly Cuba), Europe, and Japan where it has a huge following. It was first introduced to Japan 
            by an American, Horace Wilson, in 1872. The professional game has existed for some 50 years. There are 
            two leagues, Central and Pacific, and a total of 12 teams. American clubs often tour Japan at the close 
            of the regular season. At school and university level, it is extremely popular. Each summer 4,000 secondary 
            schools take part in the All Japan Baseball Tournament, which is held near the city of Osaka. And it is 
            played in India too...
          </p>
        </div>

        {/* Baseball India at a Glance */}
        <div id="basic">
          <h3 className="heading3">BASEBALL INDIA AT A GLANCE</h3>
          <ul className="basic_ul">
            <li>The Amateur Baseball Federation of India was formed in Dec 1983.</li>
            <li>First National Baseball Championship was organized in Feb 1985 at New Delhi.</li>
            <li>The Federation was affiliated with the Baseball Federation of Asia & International Baseball Federation in 1985.</li>
            <li>The Federation was recognized by National Federation by the Ministry of Y/A & Sports, Govt. of India in 1991.</li>
            <li>The Indian team participated in the Asian Baseball Championship in 1987 at Tokyo & in 1989 Seoul.</li>
            <li>The Indian Baseball team won the Bronze Medal in 1st Asian cup Baseball Championship in 1995 held at Manila, Philippines.</li>
            <li>The Federation organized 3rd Asian Cup Baseball Championship in 1999 at Chandigarh and got Silver Medal</li>
            <li>The Federation has sent baseball team 11yr, 15 yr & 17 yr in the Asian Baseball Championship held at Tokyo, Seoul and Taipei in which Indian team performed well.</li>
            <li>Baseball was introduced in School National Games in 1999 by School Games Federation of India.</li>
            <li>The Federation was recognized by Indian Olympic association in 2002.</li>
            <li>SAI Introduced Certificate Course for baseball in NIS in 2003.</li>
            <li>Baseball Clinic conducted by MLB coaches at Chandigarh in 2006 - Chennai and Hyderabad in 2007</li>
            <li>26 States Affiliated. Associations to its credit.</li>
          </ul>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default HistoryPage;